import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reporting_6QU9e",
  "use": "reporting_6QU9e-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"reporting_6QU9e\">\n    <rect x=\"3\" y=\"16\" width=\"4\" height=\"5\" fill=\"none\" stroke=\"currentColor\" />\n    <rect x=\"8\" y=\"12\" width=\"4\" height=\"9\" fill=\"none\" stroke=\"currentColor\" />\n    <rect x=\"13\" y=\"8\" width=\"4\" height=\"13\" fill=\"none\" stroke=\"currentColor\" />\n    <rect x=\"18\" y=\"4\" width=\"4\" height=\"17\" fill=\"none\" stroke=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol